var map = {
	"./BENI.png": "fae1",
	"./CHUQUISACA.png": "05a0",
	"./COCHABAMBA.png": "b1a5",
	"./LA PAZ.png": "c213",
	"./ORURO.png": "b549",
	"./PANDO.png": "29da",
	"./POTOSI.png": "09f7",
	"./SANTA CRUZ.png": "44be",
	"./TARIJA.png": "5800"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e95d";